module.exports = __webpack_public_path__ + "static/media/plugPositive.3963defd.svg";